module.exports = __webpack_public_path__ + "img/open5.01872ebe.png";